import { createSelector } from 'reselect';
import { getTr } from '../../../Report/Report.selectors';
import { getLastDays } from '../helpers';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import config from '../../../../config';

const reportUtils = ReportComponent.utils;
const DEFAULT_METRICS_STRING = reportUtils.getStrMetric();
const DEFAULT_KEYS_METRIC = reportUtils.getKeysMetric(DEFAULT_METRICS_STRING);

const normalizeColumns = (columns) => {
    if (Array.isArray(columns) && columns.length) {
        return columns;
    }
    return DEFAULT_KEYS_METRIC;
};

const ensureParameters = (parameters = {}) => ({
    ...parameters,
    group_by: parameters.group_by || config.defaultGroupBy,
    columns: normalizeColumns(parameters.columns),
    metrics: typeof parameters.metrics === 'string' && parameters.metrics.length
        ? parameters.metrics
        : DEFAULT_METRICS_STRING
});

const statistics = (state) => state.dashboard.last.data;
const parameters = (state) => state.dashboard.last.parameters;

export const mainSelector = createSelector(
    statistics,
    parameters,
    (statisticsData = [], params = {}) => {
        const normalizedParams = ensureParameters(params);
        const sourceData = Array.isArray(statisticsData) ? statisticsData : [];
        let data = '';
        const lastDays = getLastDays() || [];

        lastDays.forEach((keyDay) => {
            const dataDay = sourceData.find((item) => item.GroupBy === keyDay) || {};

            if (!dataDay.GroupBy) {
                dataDay.GroupBy = keyDay;
            }

            data += getTr(dataDay, normalizedParams, false);
        });

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    (params = {}) => {
        const normalized = ensureParameters(params);
        reportUtils.setKeyGroupBy(normalized.group_by);
        const headerNames = reportUtils.getMultiLevelHeaderNames();
        reportUtils.updateVisible(headerNames, DEFAULT_KEYS_METRIC);
        return headerNames;
    }
);

export const getMetrics = createSelector(
    () => DEFAULT_METRICS_STRING
);

export const getKeysMetric = createSelector(
    () => DEFAULT_KEYS_METRIC
);

export const getRowsCount = createSelector(
    statistics,
    (statisticsData = []) => statisticsData.length
);
